<ng-container *transloco="let t">
  <core-dialog
    (closeDialogEvent)="closeModal(false)"
    (saveDialogEvent)="onSave()"
    [saveIsDisabled]="createOrEditDialog && blogPostForm.invalid"
    [dialogTitle]="newsItemDialogTitle"
    [dialogSubtitle]="newsItemDialogSubtitle"
    [confirmButtonText]="newsItemDialogConfirmButtonText"
    [closeButtonText]="newsItemDialogCancelButtonText"
  >
    @if (createOrEditDialog) {
      <div>
        <form [formGroup]="blogPostForm">
          <div class="form-control">
            <label class="mb-4 flex items-center">
              <input
                [attr.aria-invalid]="
                  blogPostFormTitle?.invalid && blogPostFormTitle?.touched
                    ? true
                    : null
                "
                [required]="true"
                class="input input-bordered w-full grow"
                formControlName="blogPostFormTitle"
                [ngClass]="{
                  'input-error':
                    blogPostFormTitle?.invalid && blogPostFormTitle?.touched,
                }"
                placeholder="Title"
                type="text"
              />
              @if (blogPostFormTitle?.invalid && blogPostFormTitle?.touched) {
                @if (
                  blogPostFormTitle?.errors?.['minlength'] ||
                  blogPostFormTitle?.errors?.['maxlength']
                ) {
                  <p class="label-text-alt text-error">
                    {{
                      t('edit-blogpost-error-title-minMaxLength', {
                        minLength: 2,
                        maxLength: 64,
                      })
                    }}
                  </p>
                }
              }
            </label>
            <core-wysiwyg-editor
              [editorContent]="blogPostContent"
            ></core-wysiwyg-editor>
          </div>
        </form>
      </div>
    }
  </core-dialog>
</ng-container>
